// removed by extract-text-webpack-plugin
module.exports = {"bubbling":"_1uxN5Pkm5BfkB7fghbKzHp","wheat":"_10u1RzdTZmA9o_cahJ0K-2","rape":"_2p9XWcfYPDsmipgOW6L8kN","soy":"_3UNhnlTlxkPUy7naB-0i84","corn":"_2d4_M9isHP57mpsMl1z8in","sunflower":"_3ZoF11tTnpQ2RzFLg_cesZ","clogged":"_3ceA9laWKmHOHmuK4-FpjV","white":"_1XDYIIUUL92ztVSNJAT8dZ"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Game/SubComponents/Bubbles/index.css
// module id = 186
// module chunks = 0